import script from "./SectionHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionHeader.vue?vue&type=script&setup=true&lang=ts"

import "./SectionHeader.vue?vue&type=style&index=0&id=60e05f6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60e05f6e"]])

export default __exports__